<div class="brand-offer-sec">
    <div id="bannerCarousel" class="bannerCarousel">
        <owl-carousel-o [options]="customOptionsForBanner">
            <ng-container *ngFor="let data of bannerList.data">
                <ng-template carouselSlide [id]="data?.id">
                    <a (click)="GetTest(data)" [ngStyle]="{'cursor': data?.banner_link ? 'pointer ': 'not-allowed' }">
                        <div class="top-banner-wrapper">
                            <img [src]="bannerList?.cfrnt_url + data?.path" [alt]="data?.title" class="active"
                                alt="banner_image" [loading]="lazy">
                        </div>
                    </a>
                </ng-template>
            </ng-container>
        </owl-carousel-o>

    </div>
    <div class="buy-can-trust-sec bg-cryan pt-5 pb-5 ps-5 pe-5 position-relative buy-can-trust-sec-ashish">
      <img [src]='environment1 + "assets/images/light-color-T.png"' class="tata-image-container">
      <div class="vertical-line-tata"></div>


          <div class="container">
              <div class="content-heading d-flex align-items-center justify-content-between mb-4">
                  <h1 class="fw-semibold cv-text-dark">Avail Loan in 4 easy steps exclusive for you</h1>

              </div>
              <div class="row">
                  <div class="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-xxl-3 box">
                      <div class="content">
                          <div class="icon mb-3">
                              <img [src]="environment1 + 'images/new-images/01arrow.svg'" alt="01 arrow" loading="lazy">
                          </div>
                          <h3 class="cv-text-dark fw-semibold fs-4">Opt for finance </h3>
                          <p class="cv-text-dark-gray">While booking the vehicle select the finance option available</p>
                      </div>

                  </div>
                  <div class="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-xxl-3 box">
                      <div class="content">
                          <div class="icon mb-3">
                              <img [src]="environment1 + 'images/new-images/02arrow.svg'" alt="02 arrow" loading="lazy" >
                          </div>
                          <h3 class="cv-text-dark fw-semibold fs-4">Verify your details</h3>
                          <p class="cv-text-dark-gray">Fill in and verify all the necessary details for the finance
                              options
                          </p>
                      </div>

                  </div>
                  <div class="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-xxl-3 box">
                      <div class="content">
                          <div class="icon mb-3">
                              <img [src]="environment1 + 'images/new-images/03arrow.svg'" alt="03 arrow" loading="lazy" >
                          </div>
                          <h3 class="cv-text-dark fw-semibold fs-4">Select Loan Offer</h3>
                          <p class="cv-text-dark-gray">Choose an offer from the list of various offers available</p>
                      </div>

                  </div>
                  <div class="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-xxl-3 box">
                      <div class="content">
                          <div class="icon mb-3">
                              <img [src]="environment1 + 'images/new-images/04arrow.svg'" alt="04 arrow" loading="lazy" >
                          </div>
                          <h3 class="cv-text-dark fw-semibold fs-4">Get Loan</h3>
                          <p class="cv-text-dark-gray">Once your finance gets approved, the loan disbursal process is
                              initiated</p>
                      </div>

                  </div>
              </div>
          </div>
      </div>
    <div class="stripe-sec">
        <div class="container">
            <div class="row g-5">
                <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                    <div class="d-flex align-items-center item-list">
                        <div class="icon-img">
                            <img [src]='environment1 + "assets/images/ic-1.png"' class="img-fluid" alt="ic-1"
                                loading="lazy">
                        </div>
                        <div class="content">MINIMAL DOCUMENTATION</div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                    <div class="d-flex align-items-center item-list">
                        <div class="icon-img">
                            <img [src]='environment1 + "assets/images/ic-2.png"' class="img-fluid" alt="ic-2"
                                loading="lazy">
                        </div>
                        <div class="content">Up to 100% Funding</div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                    <div class="d-flex align-items-center item-list">
                        <div class="icon-img">
                            <img [src]='environment1 + "assets/images/ic-3.png"' class="img-fluid" alt=""
                                loading="lazy">
                        </div>
                        <div class="content">MULTIPLE FINANCERS AVAILABLE</div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                    <div class="d-flex align-items-center item-list">
                        <div class="icon-img">
                            <img [src]='environment1 + "assets/images/ic-4.png"' class="img-fluid" alt=""
                                loading="lazy">
                        </div>
                        <div class="content">Apply & Process Loan Online</div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                    <div class="d-flex align-items-center item-list">
                        <div class="icon-img">
                            <img [src]='environment1 + "assets/images/ic-5.png"' class="img-fluid" alt=""
                                loading="lazy">
                        </div>
                        <div class="content">Instant Approval</div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                    <div class="d-flex align-items-center item-list">
                        <div class="icon-img">
                            <img [src]='environment1 + "assets/images/ic-6.png"' class="img-fluid" alt=""
                                loading="lazy">
                        </div>
                        <div class="content">HIGHER LOAN AMOUNT</div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                    <div class="d-flex align-items-center item-list">
                        <div class="icon-img">
                            <img [src]='environment1 + "assets/images/ic-7.png"' class="img-fluid" alt=""
                                loading="lazy">
                        </div>
                        <div class="content">Attractive Interest Rate</div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                    <div class="d-flex align-items-center item-list">
                        <div class="icon-img">
                            <img [src]='environment1 + "assets/images/ic-8.png"' class="img-fluid" alt=""
                                loading="lazy">
                        </div>
                        <div class="content">Lowest EMI</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="available-offers">
        <div class="container">
            <h2 class="fw-semibold cv-text-dark" style="margin-top: -30px;">I want to enquire about loan offers</h2>


            <form [formGroup]="enquiryForm">
              <div class="row c-box-row p-4 m-3 border rounded">

                <div class="row gx-3 ps-5">
                  <div class="col-12 col-md-4 d-flex flex-column">
                    <label for="first-name" class="form-label">
                      <span class="mend">First Name</span>
                    </label>
                    <input id="first-name" type="text" class="form-control" formControlName="firstName" placeholder="Enter your full name" [attr.disabled]="userData.first_name ? true : null" />
                    <div *ngIf="isSubmitted && enquiryForm.get('firstName')?.invalid" class="text-danger">
                      First name is required.
                    </div>
                  </div>

                  <div class="col-12 col-md-4 d-flex flex-column">
                    <label for="last-name" class="form-label">
                      <span class="mend">Last Name</span>
                    </label>
                    <input id="last-name" type="text" class="form-control" formControlName="lastName" placeholder="Enter your last name" [attr.disabled]="userData.first_name ? true : null" />
                    <div *ngIf="isSubmitted && enquiryForm.get('lastName')?.invalid" class="text-danger">
                      Last name is required.
                    </div>
                  </div>

                  <div class="col-12 col-md-4 d-flex flex-column">
                    <label for="pincode" class="form-label">
                      <span class="mend">Pincode</span>
                    </label>
                    <input id="pincode" type="text" formControlName="pincode" placeholder="Enter your pincode" maxlength="6" class="form-control" inputmode="numeric" pattern="[0-9]*" (keypress)="allowOnlyNumbers($event)" (input)="addressByPincode()" />
                    <div *ngIf="isSubmitted && enquiryForm.get('pincode')?.invalid" class="text-danger">
                      <div *ngIf="enquiryForm.get('pincode')?.hasError('required')">
                        Pincode is required.
                      </div>
                      <div *ngIf="enquiryForm.get('pincode')?.hasError('pattern')">
                        Please enter pincode doesn't start with 0.
                      </div>
                    </div>
                  </div>
                </div>


                <div class="row gx-3 mt-3 ps-5">
                  <div class="col-12 col-md-4 d-flex flex-column">
                    <label for="state" class="form-label">
                      <span class="mend">State</span>
                    </label>
                    <input id="state" type="text" class="form-control" formControlName="state" placeholder="Enter your state" [attr.disabled]="userData.state ? true : null" />
                    <div *ngIf="isSubmitted && enquiryForm.get('state')?.invalid" class="text-danger">
                      State is required.
                    </div>
                  </div>

                  <div class="col-12 col-md-4 d-flex flex-column">
                    <label for="district" class="form-label">
                      <span class="mend">District</span>
                    </label>
                    <input id="district" type="text" class="form-control" formControlName="district" placeholder="Enter your district" [attr.disabled]="userData.state ? true : null" />
                  </div>

                  <div class="col-12 col-md-4 d-flex flex-column">
                    <label for="mobile" class="form-label">
                      <span class="mend">Mobile Number</span>
                    </label>
                    <input id="mobile" type="number" class="form-control" formControlName="mobile" maxlength="10" placeholder="Enter your mobile number" [attr.disabled]="userData.mobile_number ? true : null" />
                    <div *ngIf="isSubmitted && enquiryForm.get('mobile')?.invalid" class="text-danger">
                      <div *ngIf="enquiryForm.get('mobile')?.errors?.required">
                        Mobile Number is required.
                      </div>
                      <div *ngIf="enquiryForm.get('mobile')?.errors?.pattern">
                        Please enter a valid 10-digit mobile number.
                      </div>
                    </div>
                  </div>
                </div>


                <!-- <div class="row gx-3 mt-3 ps-5 justify-content-center">
                  <div class="col-md-4 d-flex justify-content-center">
                    <button type="submit" class="btn btn-primary btn-grad-primary btn-brand" (click)="onSubmit()">
                      Submit Enquiry
                    </button>
                  </div>
                </div> -->

                <div class="row gx-3 mt-3 ps-5">
                  <div class="col-12 col-md-4 d-flex flex-column">

                  </div>

                  <div class="col-12 col-md-4 d-flex flex-column">
                    <button type="submit" class="btn btn-primary btn-grad-primary btn-brand" (click)="onSubmit()">
                      Submit Enquiry
                    </button>
                  </div>

                  <div class="col-12 col-md-4 d-flex flex-column">

                  </div>
                </div>
              </div>

            </form>

            <h2 class="fw-semibold cv-text-dark">Our Finance Partners</h2>
            <div class="row c-box-row g-4">
                <div class="col">
                    <div class="carousel-container">
                        <div class="carousel">
                            <!-- <div class="carousel-item">
                      <img src="assets/fni-assets/images/axis-bank.svg" alt="Logo 1">
                  </div> -->
                            <div class="carousel-item">
                                <img src="assets/fni-assets/images/HDFC-logo.svg" alt="Logo 2">
                            </div>
                            <div class="carousel-item">
                                <img src="assets/fni-assets/images/HDBFS-logo.svg" alt="Logo 3">
                            </div>
                            <div class="carousel-item">
                                <img src="assets/fni-assets/images/sbi.svg" alt="Logo 4">
                            </div>
                            <div class="carousel-item">
                                <img src="assets/fni-assets/images/chola.svg" alt="Logo 5">
                            </div>
                            <!-- <div class="carousel-item">
                      <img src="assets/fni-assets/images/bank-of-baroda.svg" alt="Logo 6">
                  </div> -->
              <div class="carousel-item">
                <img src="assets/fni-assets/images/sundaram.svg" alt="Logo 7" />
              </div>
              <div class="carousel-item">
                <img src="assets/fni-assets/images/Tata_Capital.png" alt="Logo 8" />
              </div>
              <div class="carousel-item">
                <img
                  src="assets/fni-assets/images/yes-bank-logo.svg"
                  alt="Logo 9"
                />
              </div>

                            <!-- Duplicate items for infinite scrolling -->
                            <!-- <div class="carousel-item">
                      <img src="assets/fni-assets/images/axis-bank.svg" alt="Logo 1">
                  </div> -->
                            <div class="carousel-item">
                                <img src="assets/fni-assets/images/HDFC-logo.svg" alt="Logo 2">
                            </div>
                            <div class="carousel-item">
                                <img src="assets/fni-assets/images/HDBFS-logo.svg" alt="Logo 3">
                            </div>
                            <div class="carousel-item">
                                <img src="assets/fni-assets/images/sbi.svg" alt="Logo 4">
                            </div>
                            <div class="carousel-item">
                                <img src="assets/fni-assets/images/chola.svg" alt="Logo 5">
                            </div>
                            <!-- <div class="carousel-item">
                      <img src="assets/fni-assets/images/bank-of-baroda.svg" alt="Logo 6">
                  </div> -->
              <div class="carousel-item">
                <img src="assets/fni-assets/images/sundaram.svg" alt="Logo 7" />
              </div>
              <div class="carousel-item">
                <img src="assets/fni-assets/images/Tata_Capital.png" alt="Logo 8" />
              </div>
              <div class="carousel-item">
                <img
                  src="assets/fni-assets/images/yes-bank-logo.svg"
                  alt="Logo 9"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <h2 class="fw-semibold cv-text-dark">Available Offers</h2>
      <div class="row c-box-row g-4">
        <ng-container
          *ngIf="offersData?.length == 0 || !productLoaded; else loadingContent"
        >
          <div
            class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-4 c-box"
            *ngFor="let item of skeletonService.generateFake(3); let i = index"
          >
            <div class="box">
              <div class="box-top-content">
                <div class="ellipse ellipse-1"></div>
                <div class="ellipse ellipse-2"></div>
                <ngx-skeleton height="120px"></ngx-skeleton>
              </div>
              <div class="box-bottom-content">
                <div class="ellipse ellipse-5"></div>
                <h5><ngx-skeleton height="35px"></ngx-skeleton></h5>
                <h6><ngx-skeleton height="20px"></ngx-skeleton></h6>
                <p><ngx-skeleton height="15px"></ngx-skeleton></p>
                <a><ngx-skeleton height="40px" width="100px"></ngx-skeleton></a>
                <div class="ellipse ellipse-3"></div>
                <div class="ellipse ellipse-4"></div>
              </div>
            </div>
          </div>
        </ng-container>

                <ng-template #loadingContent>
                    <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-4 c-box"
                        *ngFor="let item of offersData | paginate: { itemsPerPage: itemsPerPage, currentPage: currentPage, totalItems: totalItemsOffers ,id: 'booking'}">
                        <div class="box">
                            <div class="box-top-content" style="height: 100px;">
                                <div class="ellipse ellipse-1"></div>
                                <div class="ellipse ellipse-2"></div>

                                <img class="img-fluid" alt="{{item.financierDetails.crmFinancierName}}"
                                    src={{setFinancierImgUrl(item.financierId)}} loading="lazy">
                            </div>
                            <div class="box-bottom-content">
                                <div class="ellipse ellipse-5"></div>
                                <h5>{{ item.financierSchemeName }}</h5>
                                <p>{{ item.description }}</p>
                                <a class="cursor" (click)="navigateToOfferDetail(item)">
                                    <img [src]="environment1 + 'images/new-images/plus.svg'" alt="plus" loading="lazy">
                                    More Details</a>
                                <div class="ellipse ellipse-3"></div>
                                <div class="ellipse ellipse-4"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 d-flex justify-content-center paging-custom " *ngIf="offersData?.length > 0">
                        <pagination-controls class="col-xs-12" *ngIf="totalItemsOffers > itemsPerPage"
                            (pageChange)="pageChangeoffer($event)" previousLabel=" " nextLabel=" " id='booking'
                            [maxSize]="maximumSize"></pagination-controls>
                    </div>
                </ng-template>


            </div>


        </div>
    </div>

</div>

<ng-template #successModal>
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" style="border:none">
            <!-- Modal Header -->
            <div class="modal-header" style="border:none">
                <button type="button" class="btn-close" aria-label="Close" (click)="closePopup()"
                    style="margin-top: -30px;">
                </button>
            </div>

            <!-- Modal Body -->
            <div class="modal-body">
                <div class="d-flex justify-content-center">
                    <img style="height: 150px;width: 150px;margin-bottom: 20px;"
                    [src]='environment1 + "assets/images/success.svg"'alt="">
                </div>
                <h2 class="text-center text-dark fw-bold mb-4">Enquiry Submitted</h2>
                <h3 class="text-center text-secondary fw-bold mb-4" style="font-size: larger;"> Thank you for your
                    enquiry! Our executive will contact you as soon as possible.</h3>
            </div>


        </div>
    </div>
</ng-template>



<!-- <ng-template #successModal>
    <div class="modal-dialog modal-dialog-centered">
    <div class="modal-header">
      <h5 class="modal-title">Success</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="closePopup()"></button>
    </div>
    <div class="modal-body">
      <p>Thank you for enquiry, our exicutive will contact you as soon as possible</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="closePopup()">Close</button>
    </div>
</div>
  </ng-template> -->
